/**
 * Convert the settings to key=value[&key=value...] pairs.
 * @param {Object} settings the ConfigurationService settings.
 * @return {String} mapping options string
 * @private
 */
export function mappingOptions(url: string, settings: any) {
    if (!settings || !settings.mappingOptions) {
        return url
    }

    const options = settings.mappingOptions
    const keys = Object.keys(options)
    if (keys.length === 0) {
        return url
    }

    const queryParams = keys
        .map((option) => `${option}=${options[option]}`)
        .join("&")
    return `${url}?${queryParams}`
}
